import React from 'react';

import { LazyPdfExportPage } from '@confluence/site-settings/entry-points/PdfExportPage.ts';
import { ADMIN_PDF_EXPORT_ANALYTICS_SOURCE } from '@confluence/site-settings/entry-points/pdfExportConstants.ts';
import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';

export const AdminPdfExportRoute: {
	(): React.JSX.Element;
	NAVIGATION_PARAMS(): {
		Screen: {
			screenEvent: {
				name: string;
			};
		};
		MainLayout: {
			navView: string;
		};
	};
} = (): React.JSX.Element => <LazyPdfExportPage />;

AdminPdfExportRoute.NAVIGATION_PARAMS = (): {
	Screen: {
		screenEvent: {
			name: string;
		};
	};
	MainLayout: {
		navView: string;
	};
} => ({
	Screen: {
		screenEvent: { name: ADMIN_PDF_EXPORT_ANALYTICS_SOURCE },
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
